module.exports = __webpack_public_path__ + "img/2.5476db56.png";